import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  FraudByFicCategoryReportAPI,
  FraudByFicCategoryReportResponse,
} from "../../../api/tenantInternalReports";
import { getCurrentFyKey, saveBlob } from "../../../lib/utils";
import { showErrorToast } from "../../../lib/toast";
import { buildFraudByFicCategoryDateWindows } from "./reportWindows";
import { RootState } from "../../../app/store";
import { ExportFormat } from "../../../api/download";

export const fetchFraudByFicCategoryReportThunk = createAsyncThunk<
  FraudByFicCategoryReportResponse,
  { fy?: string },
  { rejectValue: string }
>(
  "fraudByFicCategoryReport/fetch",
  async ({ fy }, { rejectWithValue }) => {
    try {
      fy = fy ?? getCurrentFyKey();
      return await FraudByFicCategoryReportAPI.fetch(
        buildFraudByFicCategoryDateWindows(fy)
      );
    } catch (error: any) {
      return rejectWithValue(
        error?.message || "Failed to fetch category-wise fraud summary"
      );
    }
  },
  {
    condition: ({ fy }, { getState }) => {
      const state = getState() as RootState;
      fy = fy ?? getCurrentFyKey();
      const { status, selectedFy } = state.fraudByFicCategoryReportData;

      if (status === "succeeded" && selectedFy === fy) {
        return false;
      }

      if (status === "loading") {
        return false;
      }

      return true;
    },
  }
);

export const downloadFraudByFicCategoryReportThunk = createAsyncThunk<
  void,
  { fy?: string; format: ExportFormat }
>("internalReports/downloadFraudByFicCategory", async ({ fy, format }) => {
  try {
    const date_windows = buildFraudByFicCategoryDateWindows(
      fy ?? getCurrentFyKey()
    );
    const { blob, fileName } = await FraudByFicCategoryReportAPI.download({
      date_windows,
      format,
    });
    saveBlob(blob, fileName);
  } catch (error) {
    console.error(error);
    showErrorToast("Could not start the download");
  }
});
